import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const completionStatusStyleId = 'wb-v2-completion-status-theme';

export const completionStatusBridgeStyles = {
  'wb-completion-status': {
    '--local-completion-status-pending': tokens.color.foreground.quaternary,
    '--local-completion-status-complete': tokens.color.foreground.successPrimary,
    '--local-completion-status-na': tokens.color.foreground.brandSecondary,
  },
};
